import React, { useState } from 'react';

import Button from '../../../components/Button';
import Input from '../../../components/Input';
import Action from "./action";
import WithLabelAction from '../../../components/WithLabelAction';
import SMSTipsBox from '../../../components/SMSTipsBox';

import { getSMSVerifyCode } from '../../../apis/DataReview';
import { useDispatch, useSelector } from 'react-redux';
import { useInterval, useWhichEnd } from '@mail/m-hooks';

if (process.env.MAIL_APP_PLATFORM === 'h5') {
    require('./style_h5.scss');
} else {
    require('./style.scss');
}

interface SafePhoneVerifyProps {
    phoneNumber: string;
    onCodeChange?: (code: string) => void;
    onCodeSubmit?: (code: string) => void;
}

const SafePhoneVerify: React.FC<SafePhoneVerifyProps> = ({ phoneNumber, onCodeChange }) => {
    const whichEnd = useWhichEnd();
    const dispatch = useDispatch();
    const [verifyCode, setVerifyCode] = useState('');
    const [disableBtn, setDisableBtn] = useState(false);
    const [waitSec, setWaitSec] = useState<number>(0);
    const { errorText } = useSelector((state: any) => state.VerifyCode);

    useInterval(() => {
        setWaitSec(waitSec - 1);
    }, waitSec > 0 ? 1000 : null);

    const handleGetCode = async () => {
        if (waitSec > 0 || disableBtn || !phoneNumber) return;

        setWaitSec(60);

        try {
            const res = await getSMSVerifyCode({
                safePhone: true,
            });
             if (res && res.code !== 200) {
                dispatch({
                    type: Action.UPDATE_VERIFY_INPUT_ERROR_TEXT,
                    playload: res.desc || '获取验证码失败'
                })
                setWaitSec(0); // 重置倒计时
            }
            if (res && res.code === 314) {
                setDisableBtn(true);
                dispatch({
                    type: Action.UPDATE_VERIFY_PHONE_METHOD,
                    playload: 'SMSBox',
                })
                dispatch({
                    type: Action.UPDATE_VERIFY_INPUT_ERROR_TEXT,
                    playload: ""
                })
            }
           
        } catch (error) {
            dispatch({
                type: Action.UPDATE_VERIFY_INPUT_ERROR_TEXT,
                playload: '网络错误，请重试'
            })
            setWaitSec(0);
        }
    };

    const handleCodeChange = (code: string) => {
        setVerifyCode(code);
        onCodeChange?.(code);
        if (errorText) {
            dispatch({
                type: Action.UPDATE_VERIFY_INPUT_ERROR_TEXT,
                playload: ''
            });
        }
    };

    const handleBlur = () => {
        if (!verifyCode) {
            dispatch({
                type: Action.UPDATE_VERIFY_INPUT_ERROR_TEXT,
                playload: '请输入验证码'
            })
            return;
        }
        dispatch({
            type: Action.UPDATE_VERIFY_CODE,
            playload: verifyCode
        })
    };

    const renderContent = () => (
        <div className="safe-phone-verify-wrapper">
            <div className='safe-phone-verify-phone'>{phoneNumber}</div>
            {!disableBtn ? (
                <div className='safe-phone-verify-form'>
                    <Input
                        onChange={handleCodeChange}
                        errorText={errorText}
                        onBur={handleBlur}
                        maxLength={6}
                        inputId="verify-code-input"
                        defaultValue={verifyCode}
                        placeholder="请输入手机验证码"
                        extraClass="verify-code-input"
                    />
                    <Button
                        color={disableBtn ? "disabled" : (waitSec > 0 ? "disabled" : "secondry")}
                        text={disableBtn ? "获取次数过多" : (waitSec > 0 ? `${waitSec}s重新获取` : "获取验证码")}
                        onClick={handleGetCode}
                        extraClass={(disableBtn || waitSec > 0) ? "verify-code-btn-disable" : "verify-code-btn"}
                    />
                </div>
            ) : <SMSTipsBox tipsLabel='请使用安全手机扫描二维码，快速发送短信验证'/>}
        </div>
    );

    return (
        !!whichEnd.h5 ? (
            <WithLabelAction
                label="验证安全手机"
                htmlFor="verify-code-input"
                required={true}
            >
                {renderContent()}
            </WithLabelAction>
        ) : (
            <WithLabelAction
                label="验证安全手机"
                htmlFor="verify-code-input"
                required={true}
            >
                {renderContent()}
            </WithLabelAction>
        )
    );
};

export default SafePhoneVerify;